module.exports = __webpack_public_path__ + "static/media/masverde.79ceff84.svg";